import NotificationsList from "../../components/NotificationsList/NotificationsList";
import styles from "./Admin.module.css";
const Admin = () => {
  return <div className={styles.container}>{<NotificationsList />}</div>;
};

export default Admin;
